'use strict';

var __chunk_1 = require('./chunk-ba04ad2f.js');

function append(a, bs) {
  return __chunk_1.isString(bs) ? bs + a : bs.concat([a]);
}

module.exports = append;
